import { CONFIGURATION_TYPES, Palette, ThemeConfiguration } from 'mm-theme-configuration';
import { PaletteManager } from './paletteManager';
import { translate } from './themeConfigurationTranslator';
import { getElevationType } from './boxShadow';
import { AspectRatio } from '../base/partials/image/image.types';

export class ThemeManager {
  paletteManager: PaletteManager;

  themeConfiguration: ThemeConfiguration;

  constructor(palette: Palette, themeConfiguration: ThemeConfiguration) {
    this.themeConfiguration = themeConfiguration;
    this.paletteManager = new PaletteManager(palette);
  }

  instructions = {
    [CONFIGURATION_TYPES.COLOR]: (key: string) => this.paletteManager.getColorByKey(key),
    [CONFIGURATION_TYPES.NUMBER]: (key: number) => key,
    [CONFIGURATION_TYPES.BOX_SHADOW]: (key: string) => getElevationType(key),
    [CONFIGURATION_TYPES.TYPOGRAPHY]: (key: string) => key,
    [CONFIGURATION_TYPES.BOOLEAN]: (key: boolean) => key,
    [CONFIGURATION_TYPES.ALIGNMENT]: (key: string) => key,
    [CONFIGURATION_TYPES.ASPECT_RATION]: (key: AspectRatio) => key,
    [CONFIGURATION_TYPES.SEMANTIC_TAG]: (key: string) => key,
  };

  getConfiguration() {
    return {
      ...translate(this.instructions, this.themeConfiguration),
      fontSizeMap: this.paletteManager.getFontSizeMap(),
    };
  }
}
